import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgPrincipleSharedModule } from '@principle-theorem/ng-principle-shared';
import { NgSharedModule } from '@principle-theorem/ng-shared';
import { CheckinAppointmentActionService } from './actions/checkin-appointment-action.service';
import { CheckoutAppointmentActionService } from './actions/checkout-appointment-action.service';
import { CompleteAppointmentActionService } from './actions/complete-appointment-action.service';
import { ConfirmAppointmentActionService } from './actions/confirm-appointment-action.service';
import { StartAppointmentActionService } from './actions/start-appointment-action.service';
import { AppointmentCardActionComponent } from './appointment-card-action/appointment-card-action.component';
import { AppointmentCardActionsComponent } from './appointment-card-actions.component';

@NgModule({
  imports: [
    CommonModule,
    NgPrincipleSharedModule,
    NgSharedModule,
    AppointmentCardActionsComponent,
    AppointmentCardActionComponent,
  ],
  providers: [
    StartAppointmentActionService,
    CheckoutAppointmentActionService,
    CompleteAppointmentActionService,
    CheckinAppointmentActionService,
    ConfirmAppointmentActionService,
  ],
  exports: [AppointmentCardActionsComponent],
})
export class AppointmentCardActionsModule {}
